var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolderOpen = function SvgFolderOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 25 25",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.665 20.051c.186.28.499.449.835.449h15c.4 0 .762-.238.919-.606l3-7A.998.998 0 0 0 21.5 11.5h-1v-4c0-1.103-.897-2-2-2h-6.1l-2.284-1.787A1 1 0 0 0 9.5 3.5h-5c-1.103 0-2 .897-2 2v14h.007a1 1 0 0 0 .158.551M17.841 18.5H5.017l2.143-5h12.824zm.659-11v4h-12c-.4 0-.762.238-.919.606L4.5 14.629V7.5z"
  })));
};
export default SvgFolderOpen;